export const formFields = [
  { label: 'Plan Type / Threat', key: 'thread', isRequired: true },
  { label: 'Owner First Name', key: 'planOwnerfirstName' },
  { label: 'Owner Last Name', key: 'planOwnerlastName' },
  { label: 'Email', key: 'email' },
  { label: 'Phone', key: 'phone', type: 'Phone' },
];
